"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackBeforeUnload = exports.track = exports.tracker = void 0;

var _usageTracker = require("usage-tracker");

var _isApiBlackListed = require("ui-addon-upgrades/_core/common/navigation/isApiBlackListed");

var _events = _interopRequireDefault(require("ui-addon-upgrades/events.yaml"));

var AMPLITUDE_APP_NAME = 'upgrades';
var tracker = (0, _usageTracker.createTracker)({
  events: _events.default,
  properties: {
    namespace: AMPLITUDE_APP_NAME
  }
});
exports.tracker = tracker;

var _beaconTracker = tracker.clone({
  isBeforeUnload: true
});

var _transformEventProperties = function _transformEventProperties(eventProperties) {
  if (!eventProperties) return {};
  var notAssigned = 'Not assigned';
  var repInfo = eventProperties.repInfo;
  delete eventProperties.repInfo;
  eventProperties.repName = repInfo ? repInfo.name || notAssigned : notAssigned;
  return eventProperties;
};

var track = function track(eventKey, eventProperties) {
  if ((0, _isApiBlackListed.isApiBlackListed)()) {
    return;
  }

  eventProperties = _transformEventProperties(eventProperties);
  tracker.track(eventKey, eventProperties);
}; // Uses beacon to ensure events get sent if tracking just before the page unloads
// https://product.hubteam.com/docs/usage-tracking-manual/docs/javascript/external-link-click-tracking.html


exports.track = track;

var trackBeforeUnload = function trackBeforeUnload(eventKey, eventProperties) {
  if ((0, _isApiBlackListed.isApiBlackListed)()) {
    return;
  }

  eventProperties = _transformEventProperties(eventProperties);

  _beaconTracker.track(eventKey, eventProperties);
};

exports.trackBeforeUnload = trackBeforeUnload;